module.exports = __webpack_public_path__ + "assets/img/17_1041.b714db48.jpg";